/* eslint react/prop-types: 0 */
import React, { useState } from 'react'
import { Alert, Button, ButtonContainer, Card, DetailList, FormInput, FormInputText, FormInputTextArea } from 'camino-react'

import { cloudhelpPatch, cloudhelpPost } from '../../utilities/CloudHelp'

import WorkflowActions from './Actions'
import WorkflowConditions from './Conditions'

const WorkflowForm = ({ workflow, options, type }) => {
  const [title, setTitle] = useState(workflow.title)
  const [description, setDescription] = useState(workflow.description)
  const [conditions, setConditions] = useState(workflow.conditions)
  const [actions, setActions] = useState(workflow.actions)
  const [errors, setErrors] = useState([])

  const save = () => {
    workflow.id ? updateWorkflow() : createWorkflow()
  }

  const createWorkflow = () => {
    const data = {
      workflow: {
        title,
        description,
        conditions,
        actions,
        type
      }
    }

    cloudhelpPost('/api/workflows', data)
      .then((response) => {
        window.location.href = response.data.workflow.href
      })
      .catch(error => setErrors(error.response.data.workflow.errors))
  }

  const updateWorkflow = () => {
    const data = {
      workflow: {
        title,
        description,
        conditions,
        actions,
        id: workflow.id
      }
    }

    cloudhelpPatch(`/api/workflows/${workflow.id}`, data)
      .then((response) => {
        window.location.href = response.data.workflow.href
      })
      .catch(error => setErrors(error.response.data.workflow.errors))
  }

  return (
    <>
      {!!errors.length && (
        <Alert type="error">
          {errors}
        </Alert>
      )}

      <div className="flex border-b-2 mb-4">
        <div className="w-1/2">
          <DetailList
            list={[
              {
                title: 'Title and description',
                content: 'The title and description of this workflow, to describe what purpose it is for and what it does'
              }
            ]}
          />
        </div>

        <div className="w-1/2">
          <Card>
            <FormInput label="Title">
              <FormInputText
                value={title}
                onValue={setTitle}
              />
            </FormInput>

            <FormInput label="Description">
              <FormInputTextArea
                value={description}
                onValue={setDescription}
                rows="5"
              />
            </FormInput>
          </Card>
        </div>
      </div>

      <div className="flex border-b-2 mb-4">
        <div className="w-1/2">
          <DetailList
            list={[
              {
                title: 'Conditions',
                content: 'These are the conditions a Ticket must abide before the below actions are performed.'
              }
            ]}
          />
        </div>

        <div className="w-1/2">
          <WorkflowConditions
            conditions={conditions}
            setConditions={setConditions}
            options={options}
            type={type}
          />
        </div>
      </div>

      <div className="flex border-b-2">
        <div className="w-1/2">
          <DetailList
            list={[
              {
                title: 'Actions',
                content: 'The actions that will happen to a Ticket if it abides to the above conditions.'
              }
            ]}
          />
        </div>

        <div className="w-1/2">
          <WorkflowActions
            actions={actions}
            setActions={setActions}
            options={options}
            type={type}
          />
        </div>
      </div>

      <ButtonContainer center spaced>
        <a href="/workflows" className="button button--outline duration-300">
          Cancel
        </a>

        <Button onClick={save}>
          Save
        </Button>
      </ButtonContainer>

    </>
  )
}

export default WorkflowForm
